import React from 'react';

/**
 * Reusable stats strip.
 */
const StatsStrip = ({ stats = [], dark = false }) => {
  return (
    <div className={`stats-strip${dark ? ' stats-strip--dark' : ''}`}>
      {stats.map((stat) => (
        <div className="stat" key={stat.label}>
          <div className="stat__number">{stat.number}</div>
          <div className="stat__label">{stat.label}</div>
        </div>
      ))}
    </div>
  );
};

export default StatsStrip;
